import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import SocialStats from "@/components/landing/SocialStats";
import About from "@/components/landing/About";
import AudienceDemographics from "@/components/landing/AudienceDemographics";
import PastCollaborations from "@/components/landing/PastCollaborations";
import Services from "@/components/landing/Services";
import Portfolio from "@/components/landing/Portfolio";
import Testimonials from "@/components/landing/Testimonials";
import ContactForm from "@/components/landing/ContactForm";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main className="relative">
      <Header />
      <Hero />
      <SocialStats />
      <About />
      <AudienceDemographics />
      <PastCollaborations />
      <Services />
      <Portfolio />
      <Testimonials />
      <ContactForm />
      <Footer />
    </main>
  );
}
